__turbopack_context__.v({
  "menu": "Header-module__KHjLKa__menu",
  "navbar": "Header-module__KHjLKa__navbar",
  "sideMenu": "Header-module__KHjLKa__sideMenu",
  "sidebarMenu": "Header-module__KHjLKa__sidebarMenu",
  "sidebarWrapper": "Header-module__KHjLKa__sidebarWrapper",
  "subMenu": "Header-module__KHjLKa__subMenu",
  "subMenuWrapper": "Header-module__KHjLKa__subMenuWrapper",
});
